import { render, staticRenderFns } from "./AllChat.vue?vue&type=template&id=5ab0c85f&scoped=true&"
import script from "./AllChat.vue?vue&type=script&lang=js&"
export * from "./AllChat.vue?vue&type=script&lang=js&"
import style0 from "./AllChat.vue?vue&type=style&index=0&id=5ab0c85f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab0c85f",
  null
  
)

export default component.exports